module.exports = __webpack_public_path__ + "static/newsletter-203bc3f4b67b3e614e2f0c9bb7b1e69c.jpg";